
nnip.classes.Globals = function() {
  this.globalNumberToCurrency = function(number, removeCurrency, precision, locale) {
    precision = (precision || precision === 0 ? precision : 2);
    if (typeof (number) === 'number' || typeof (number) === 'string') {
      if (!locale) {
        locale = document.getElementsByTagName('html')[0].getAttribute('lang').replace('_', '-');
      }
      return Number(number).toLocaleString(locale, {
        currency: 'EUR',
        minimumFractionDigits: precision,
        style: (removeCurrency ? 'decimal' : 'currency'),
      });
    }
    return false;
  }
}
